import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { observer } from 'mobx-react';
import { RequestPage as PPFIcon } from '@mui/icons-material';

import QAPContext from '../../../context/QAPContext';
import clientInfoTabs from '../ClientInfo/tabs';

import {
  ProfileCardCircleIconButton,
  StyledPersonIcon,
} from './styles';

const ClientPostPaymentFormButton = ({
  userId,
}) => {
  const { openQAP } = useContext(QAPContext);

  return (
    <ProfileCardCircleIconButton
      onClick={() => openQAP(userId, clientInfoTabs.CLIENT_INFO)}
      aria-label="Post-payment form"
    >
      <StyledPersonIcon>
        <PPFIcon fontSize="inherit" />
      </StyledPersonIcon>
    </ProfileCardCircleIconButton>
  );
};

ClientPostPaymentFormButton.propTypes = {
  userId: PropTypes.string.isRequired,
};

export default compose(
  observer,
)(ClientPostPaymentFormButton);
